/** Funnel list filter state types */

export type FunnelStatusFilter = 'all' | 'active' | 'inactive' | 'draft'

export type SortField = 'name' | 'priority' | 'createdAt' | 'updatedAt' | 'version'

export type SortDirection = 'asc' | 'desc'

export type ViewMode = 'flow' | 'pricing'

export interface FunnelFilters {
  search: string
  status: string[]
  funnelType: string[]
  currency: string[]
  trafficType: string[]
  productType: string[]
  countries: string[]
  dateFrom: string
  dateTo: string
  hasRules: boolean | null
  hasSteps: boolean | null
  sortField: SortField
  sortDirection: SortDirection
}

export const DEFAULT_FILTERS: FunnelFilters = {
  search: '',
  status: [],
  funnelType: [],
  currency: [],
  trafficType: [],
  productType: [],
  countries: [],
  dateFrom: '',
  dateTo: '',
  hasRules: null,
  hasSteps: null,
  sortField: 'updatedAt',
  sortDirection: 'desc',
}
